import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Paper, Typography, TextField, Button, Alert, Stack } from '@mui/material';
import { authorizedViewerUrl, savePdf } from '../services/viewerAccess';

const apiRoot = `${process.env.REACT_APP_API_URL || ''}/api/secure-viewer`;

export default function SecureShare() {
  const [shareToken] = useState(() => window.location.hash.slice(1));
  useEffect(() => { window.history.replaceState(null, '', window.location.pathname); }, []);
  const [code, setCode] = useState('');
  const [access, setAccess] = useState(null);
  const [records, setRecords] = useState(null);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const run = async callback => {
    setBusy(true); setError('');
    try { await callback(); } catch (err) {
      setError(err.response?.data?.error || 'Access is unavailable or expired. Contact the sender.');
      if ([401, 403, 404].includes(err.response?.status)) { setAccess(null); setRecords(null); }
    } finally { setBusy(false); }
  };
  const headers = { Authorization: `Bearer ${access}` };
  return <Container maxWidth="sm" sx={{ py: 6 }}><Paper sx={{ p: 4 }}><Stack spacing={2}>
    <Typography variant="h5">Shared records</Typography>
    {error && <Alert severity="error">{error}</Alert>}
    {message && <Alert severity="info">{message}</Alert>}
    {!records ? <>
      <Typography>Access requires a code sent to the email address designated by the sender.</Typography>
      <Button disabled={busy || !shareToken} onClick={() => run(async () => {
        const response = await axios.post(`${apiRoot}/shares/challenge`, { shareToken });
        setMessage(response.data.message);
      })}>Send access code</Button>
      <TextField label="One-time code" value={code} onChange={event => setCode(event.target.value)}
        inputProps={{ maxLength: 6, inputMode: 'numeric' }} autoComplete="one-time-code" />
      <Button variant="contained" disabled={busy || code.length !== 6} onClick={() => run(async () => {
        const response = await axios.post(`${apiRoot}/shares/verify`, { shareToken, code });
        const token = response.data.accessToken;
        const content = await axios.get(`${apiRoot}/shares/content`, { headers: { Authorization: `Bearer ${token}` } });
        setAccess(token); setRecords(content.data); setCode(''); setMessage('');
      })}>Verify access</Button>
    </> : <>
      <Typography>This access expires shortly and can be revoked by the sender.</Typography>
      {records.images && <Button variant="contained" disabled={busy} onClick={() => run(async () => {
        const url = authorizedViewerUrl(records.studyInstanceUID, access);
        window.location.assign(url);
      })}>View images</Button>}
      {records.reports.map(report => <Button key={report.id} disabled={busy} onClick={() => run(async () => {
        const response = await axios.get(`${apiRoot}/shares/reports/${report.id}`, { headers, responseType: 'blob' });
        savePdf(response, report.filename);
      })}>Download report</Button>)}
      <Button disabled={busy} onClick={() => run(async () => {
        await axios.delete(`${apiRoot}/shares/session`, { headers });
        setAccess(null); setRecords(null); setCode('');
      })}>End access</Button>
    </>}
  </Stack></Paper></Container>;
}
